import axios from 'axios';

const loadItems = (options, obj) => {
  axios.get('/financial/refund-note/employees/', {
    params: obj,
  }).then(response => {
    options.commit('SET_ITEMS', response.data);
  });
};

export default { loadItems };
